import API from "./API"

export const fetchSeedSelectorHash = seedSelectorJson =>
  API.post("/seed-selector-pdf-data/", { seed_selector_data: seedSelectorJson })
